<!-- 
共通フッタの画面部品
-->

<template>
  <v-footer color="grey darken-1 white--text text-caption">
    <v-spacer></v-spacer>
    <v-col cols="auto"> <router-link to="/tos">利用規約／プライバシーポリシー</router-link> </v-col>
    <v-spacer></v-spacer>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scope>
footer a {
  text-decoration: none !important;
  color: inherit !important;
}
</style>
